import { atom } from "recoil";
import {
  PolicyHolderType,
  RegularDriverType,
} from "../interfaces/PolicyHolder";
import { VehicleDetailsType } from "../interfaces/VehicleDetails";
import { ResidentialAddressType } from "../interfaces/ResidentialAddress";
import { ParkingType } from "../interfaces/Parking";
import { LicenseType } from "../interfaces/License";

export const policyHolderState = atom<PolicyHolderType>({
  key: "policyHolderState",
  default: {
    idType: "",
    idNumber: "",
    title: "",
    name: "",
    surname: "",
    day: "",
    month: "",
    year: "",
    gender: "",
    maritalStatus: "",
    employmentStatus: "",
    mobilePhoneNumber: "",
    email: "",
  },
});

export const vehicleDetailsState = atom<VehicleDetailsType>({
  key: "vehicleDetailsState",
  default: {
    mmCode: "",
    make: "",
    model: "",
    vehicleYear: "",
    color: "",
    typeOfUse: "",
    canopyCover: "",
    modelCode: "",
    modelDetails: "",
    vehicleStatus: null,
    hasMMCode: null,
  },
});

export const residentialAddressState = atom<ResidentialAddressType>({
  key: "residentialAddressState",
  default: {
    address1: "",
    address2: "",
    address3: "",
    suburb: "",
    postalCode: "",
  },
});

export const nightParkingState = atom<ParkingType>({
  key: "nightParkingState",
  default: {
    parkingMethod: "",
    parkingLocation: "",
    address1: "",
    address2: "",
    address3: "",
    suburb: "",
    postalCode: "",
  },
});

export const dayParkingState = atom<ParkingType>({
  key: "dayParkingState",
  default: {
    parkingMethod: "",
    parkingLocation: "",
    address1: "",
    address2: "",
    address3: "",
    suburb: "",
    postalCode: "",
  },
});

export const regularDriverState = atom<RegularDriverType>({
  key: "regularDriverState",
  default: {
    policyHolderIsDriver: null,
    relationshipToPolicyHolder: "",
    idType: "",
    idNumber: "",
    title: "",
    name: "",
    surname: "",
    day: "",
    month: "",
    year: "",
    gender: "",
    maritalStatus: "",
    employmentStatus: "",
    mobilePhoneNumber: "",
    email: "",
  },
});

export const licenseState = atom<LicenseType>({
  key: "licenseState",
  default: {
    day: "",
    month: "",
    year: "",
    licenseType: "",
    licenseCode: "",
    haveCurrentInsurance: null,
    theftClaimFreeYears: "",
    coverClaimFreeYears: "",
  },
});
